import { render, staticRenderFns } from "./Validations.vue?vue&type=template&id=4d324d85&"
import script from "./Validations.vue?vue&type=script&lang=js&"
export * from "./Validations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports